<div class="stat-group">
  <article>{{ advert().streetNameAndHouseNumber }}</article>
  <article>{{ advert().postalCodeAndCity }}</article>
</div>

<div class="stat-group">
  <article>
    {{ advert().hasNoContactAssigned ? ('SHARED_COMPONENT.NO_CONTACT' | translate) : advert().contactDisplay }}
  </article>
  @if (advert().hasSubstituteContact) {
    <article>
      {{ advert().substituteContact.firstName }} {{ advert().substituteContact.lastName }}
    </article>
  }
</div>

<div class="stat-group">
  <article>{{ 'SHARED_COMPONENT.MOVE_OUT' | translate }}</article>
  <article>{{ advert().moveOutDate | convertDate }}</article>
  <view-unit-intranet [internalId]="advert().internalId" />
  <view-unit-acm [internalId]="advert().internalId" />
</div>

<div class="stat-group">
  <article>{{ 'KEY_FACTS.availableFromDate' | translate }}</article>
  <article>
    {{
    advert().isAvailableFromNowOn
    ? ('KEY_FACTS.availableFromNowOnTeaser' | translate)
    : (advert().availabeFrom | convertDate)
    }}
  </article>
</div>

<div class="stat-group rent">
  <article>{{ 'SHARED_COMPONENT.LAST_RENT' | translate }}</article>
  @if (advert().lastRent) {
    <article>{{ advert().lastRent | numeral }} {{ advert().localization.currency }}</article>
  }
  @if (!advert().lastRent) {
    <article>-</article>
  }
</div>

<div class="stat-group rent">
  <article>{{ 'SHARED_COMPONENT.NEW_RENT' | translate }}</article>
  @if (advert().newRent) {
    <article>{{ advert().newRent | numeral }} {{ advert().localization.currency }}</article>
  }
  @if (!advert().newRent) {
    <article>-</article>
  }
</div>
